import React from "react";
import { useTranslation } from "react-i18next";
import useFormatCurrency from "../../../yoello-lib/modules/localisation/useCurrency";
import Styles from "../../../scss/orderDetails.module.scss";
import InfoCard from "./InfoCard";

interface IDiscountDetailsProps {
    placed_order_discount_frozen: string | null;
    placed_order_discount_value: any;
    placed_order_discount_code: any;

}

export function DiscountDetails({ placed_order_discount_frozen, placed_order_discount_value, placed_order_discount_code }: IDiscountDetailsProps) {
    const { t } = useTranslation();
    const { formatCurrency } = useFormatCurrency();
    function getDiscountValue(discountsDetails: any) {
        if (discountsDetails.type === 'PERCENTAGE') {
            return `- ${discountsDetails.value}%`
        } else {
            return `- ${formatCurrency(placed_order_discount_value || 0)}`
        }
    }
    return placed_order_discount_frozen ?
        <InfoCard label={t("orderHistory.modal.DiscountCode")}
            value={`- ${formatCurrency(placed_order_discount_value || 0)}`}
            className={Styles.BillLabels}
            wrapperClassName={Styles.DiscountOnBill}
            subText={`${placed_order_discount_code} (${getDiscountValue(placed_order_discount_frozen)})`} />
        : null;
}